export default __webpack_public_path__ + "static/media/participant.06379ecb.svg";